export default __webpack_public_path__ + "static/logos-8b90150a3814256f3f91b341116ce928.png";